<template>
  <v-container
    id="detalhe-historico-inadimplencia-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <dashboard-filtro-datas
              :primeiro="enablePrimeiroDia"
              :ultimo="enableUltimoDia"
              :empresas="enableEmpresa"
              :cliente="enableClientes"
              :url="link"
            />
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <h3 class="text-center">
                        Histórico Inadimplência
                      </h3>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashboard-historico-inadimplencia />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <h3 class="text-center">
                        Detalhamento Inadimplência
                      </h3>
                    </v-col>
                  </v-row>
                  <v-row v-if="loading">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        :style="styleObject"
                        class="text-center"
                      >
                        <v-icon
                          light
                          class="custom-loader"
                          :style="styleObject"
                        >
                          mdi-cached
                        </v-icon>
                        Carregando dados...
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="error">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        class="alert alert-danger"
                      >
                        {{ error }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <!-- Tabela principal Inicio -->
                      <div
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 20%;"
                                class="black--text title"
                              >
                                Data vencimento(mês)
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 40%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 20%;"
                                class="black--text title"
                              >
                                Valor pagar vencindo
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 20%;"
                                class="black--text title"
                              >
                                Dias vencido
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamento"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 20%;"
                              >
                                {{ item.data_vencimento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;  width: 40%;"
                              >
                                <v-icon
                                  id="iconInformationValorVencido"
                                  class="text-left"
                                  :style="styleObjectIcon"
                                  @click="expandedNome(item.data_vencimento, item.saldo, item.dias_vencido)"
                                >
                                  {{ iconeNome }}
                                </v-icon>
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 20%;"
                              >
                                {{ item.saldo }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 20%;"
                              >
                                {{ item.dias_vencido }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela principal Fim -->
                      <!-- Tabela Nome Incio -->
                      <div
                        v-if="expandNome"
                        id="idTable"
                        style="overflow-x: auto; max-width: 100%;"
                      >
                        <table
                          style="width: 100%; color: black; border-collapse: collapse;"
                          class="elevation-1"
                        >
                          <thead>
                            <tr>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 20%;"
                                class="black--text title"
                              >
                                Data vencimento(mês)
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 40%;"
                                class="black--text title"
                              >
                                Nome reduzido
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center;  width: 20%;"
                                class="black--text title"
                              >
                                Valor pagar vencindo
                              </th>
                              <th
                                id="dadoMovimentacaoHeader"
                                style="text-align: center; width: 20%;"
                                class="black--text title"
                              >
                                Dias vencido
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in dadosDetalhamentoNome"
                              :key="item.id"
                              style="cursor: pointer;"
                            >
                              <td
                                id="dadoMovimentacao"
                                style="text-align: center; width: 20%;"
                              >
                                {{ item.data_vencimento }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: left;  width: 40%;"
                              >
                                {{ item.nome_reduzido }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 20%;"
                              >
                                {{ item.saldo }}
                              </td>
                              <td
                                id="dadoMovimentacao"
                                style="text-align: right; width: 20%;"
                              >
                                {{ item.dias_vencido }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- Tabela nome Fim -->
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import ContasReceber from '../../../../../services/contasreceber'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardContasVencidaDetalhamento',
    emits: ['setDadosDetalhamento'],
    components: {
      DashboardHistoricoInadimplencia: () => import('../../../graficos/ContasReceber/PaginaDetalhamento/HistoricoInadimplencia'),
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableClientes: true,
      link: localStorage.linkContasReceber,
      select: [],
      selectClientes: [],
      headersDetalhamento: [
        { text: 'Data vencimento(mês)', value: 'data_vencimento', width: '250px', align: 'left', class: 'black--text title' },
        { text: 'Nome reduzido', value: 'nome_reduzido', width: '250px', class: 'black--text title' },
        { text: 'Valor pagar vencindo', value: 'saldo', width: '170px', align: 'right', class: 'black--text title' },
        { text: 'Dias vencido', value: 'dias_vencido', width: '170px', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      dadosDetalhamentoNome: [],
      iconeNome: 'mdi-plus',
      expandNome: false,
      loading: false,
      error: null,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, selectVendedores, selectArea, selectRede, selectSupervisor, selectReceita, selectSegmento, selectClassificacao, selectProduto, selectCidade, selectCategoria, selectPromotor, selectLinhasProducao, primeiroDiaStatus, dateStatus, selectMotorista, selectStatusEntrega, selectOrdem, selectOpcaoOrdenacao, selectOrientacaoOrdem, selectClientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.selectClientes = selectClientes

        this.updateDate()
      },

      updateDate () {
        this.dadosDetalhamento = []

        this.showDelhamentoHistoricoInadimplencia()
        eventEmit.$emit('set-dados-detalhamento', this.primeiroDia, this.ultimoDia, this.select, this.selectClientes)
      },

      async showDelhamentoHistoricoInadimplencia () {
        this.loading = true

        await ContasReceber.showHistoricoInadimplencia(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.dadosExibicao.map((item) => {
              var listaDetalhamento = ({
                data_vencimento: item.data_vencimento,
                nome_reduzido: item.nome_reduzido,
                saldo: item.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                dias_vencido: item.dias_vencido,
              })

              return listaDetalhamento
            })
          } else if (resposta.data.msg === 'Não há dados disponíveis') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      async expandedNome (data, saldo, dias) {
        if (!this.expandNome) {
          this.iconeNome = 'mdi-minus'
          this.expandNome = true

          const dados = [
            {
              data_vencimento: data,
              nome_reduzido: 'Todo(s) nome(s) reduzido(s)',
              saldo: saldo,
              dias_vencido: dias,
            },
          ]

          this.dadosDetalhamento = dados

          this.loading = true

          await ContasReceber.showHistoricoInadimplenciaMensal(data, this.select, localStorage.tokencontrato).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamentoNome = resposta.data.dadosExibicao.map((item) => {
                var listaDetalhamento = ({
                  data_vencimento: item.data_vencimento,
                  nome_reduzido: item.nome_reduzido,
                  saldo: item.saldo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  dias_vencido: item.dias_vencido,
                })

                return listaDetalhamento
              })
            } else if (resposta.data.msg === 'Não há dados disponíveis') {
              this.dadosDetalhamentoNome = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.error = e.message

              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        } else {
          this.expandNome = false
          this.iconeNome = 'mdi-plus'
          this.showDelhamentoHistoricoInadimplencia()
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 395px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>

<style lang="sass">
  #bloco1
    margin-left: -5rem

  #templateNome
    margin-left: -1rem

  #templateLancamento
    margin-left: -1rem

  #templateDataVencimento
    margin-left: -1rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
